import { createSlice } from '@reduxjs/toolkit';
import { userResetPassword } from './thunk';

export const initialState = {
	forgetSuccessMsg: null,
	forgetError: null,
	resetSuccessMsg: null,
	resetError: null,
	disabledUser: null,
};

const forgotPasswordSlice = createSlice({
	name: 'forgotpwd',
	initialState,
	reducers: {
		userForgetPasswordSuccess(state, action) {
			state.forgetSuccessMsg = action.payload;
			state.forgetError = false;
			state.disabledUser = null;
		},
		userForgetPasswordError(state, action) {
			state.forgetError = action.payload;
			state.disabledUser = action.payload.includes('403') ? true : false
		},
		userResetPasswordSuccess(state, action) {
			state.resetSuccessMsg = action.payload;
			state.forgetError = false;
		},
		userResetPasswordError(state, action) {
			state.resetError = action.payload;
		},
	},
});

export const {
	userForgetPasswordSuccess,
	userForgetPasswordError,
	userResetPasswordSuccess,
	userResetPasswordError,
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
